import InfoCard from '@/components/ProjectDetails/Cards/InfoCard';
import styles from '@/components/LeadSource/ManualLead/index.less';
import { Avatar, Button, Collapse, Flex, Space, Typography } from 'antd';
import { F } from '@/utils/intl';
import { LeadOptionCard } from '@/components/Lead/RelatedLeads';
import { EditOutlined } from '@ant-design/icons';
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useIntl } from 'umi';
import { LeadModel } from '@/typings/models/Lead';


export default function AddProjectRelatedLeads({ foundCustomers, onUseDifferentContact }) {
  const intl = useIntl();
  const dispatch = useDispatch()
  const [relatedProjectsVisible, setRelatedProjectsVisible] = useState(true);

  const handleRelatedLeadClick = (lead) => {
    dispatch({
      type: 'leads/toggleLeadDetailsDrawer',
      payload: {
        lead,
      },
    });
  };

  const toggleRelatedProjectsVisible = () => {
    setRelatedProjectsVisible(!relatedProjectsVisible);
  };

  useEffect(() => {
    setRelatedProjectsVisible(false);
  }, [foundCustomers]);

  // Get customer info from the first found customer
  const customerInfo = foundCustomers.length > 0 ? foundCustomers[0] : null;
  const customerName = customerInfo
    ? `${customerInfo.firstname || ''} ${customerInfo.lastname || ''}`.trim()
    : '';

  const relatedLeads = useMemo(() => {
    const allLeads: LeadModel[] = [];
    foundCustomers.forEach((customer: any) => {
      if (customer.leads && customer.leads.length > 0) {
        allLeads.push(...customer.leads);
      }
    });
    return allLeads
  }, [foundCustomers])



  return (
    relatedLeads.length > 0 &&
    customerInfo && (
      <InfoCard
        headerClassName={styles.relatedLeadsHeader}
        title={
          <Flex
            gap={12}
            justify={'space-between'}
            align="center"
            style={{ width: '100%' }}
          >
            <Flex gap={12} align={'center'}>
              <Avatar
                size={48}
                src={customerInfo.avatar}
                style={{ flexShrink: 0 }}
              >
                {customerName.slice(0, 2).toUpperCase()}
              </Avatar>
              <Flex vertical gap={4} style={{ flex: 1 }}>
                <div style={{ fontWeight: 600, fontSize: 16 }}>
                  {customerName ||
                    intl.formatMessage({
                      id: 'pages.customers.unknown',
                      defaultMessage: 'Unknown Customer',
                    })}
                </div>
                <Space size={12} wrap style={{ fontSize: 9 }}>
                  {customerInfo.email && (
                    <Typography.Text
                      style={{ fontSize: 12 }}
                      type={'secondary'}
                    >
                      {customerInfo.email}
                    </Typography.Text>
                  )}
                  {customerInfo.email && customerInfo.phone && <span>|</span>}
                  {customerInfo.phone && (
                    <Typography.Text
                      style={{ fontSize: 12 }}
                      type={'secondary'}
                    >
                      {customerInfo.phone}
                    </Typography.Text>
                  )}
                </Space>
              </Flex>
            </Flex>
            <Button
              size={'small'}
              style={{ background: 'transparent' }}
              variant={'outlined'}
              onClick={toggleRelatedProjectsVisible}
              color={'geekblue'}
            >
              {relatedProjectsVisible ? (
                <F id={'common.hide'} defaultMessage={'Hide'} />
              ) : (
                <F
                  id={`pages.lead.project${
                    relatedLeads.length > 1 ? 's' : ''
                  }.count`}
                  defaultMessage="{count} Projects"
                  values={{ count: relatedLeads.length }}
                />
              )}
            </Button>
          </Flex>
        }
        variant="blue"
        className={styles.infoCardSection}
      >
        <Collapse
          className={'collapse-no-header'}
          activeKey={relatedProjectsVisible ? ['1'] : []}
          ghost
          bordered={false}
          style={{ background: 'transparent' }}
        >
          <Collapse.Panel key="1" header={null} showArrow={false}>
            <div className={styles.relatedLeadsContainer}>
              <Space direction="vertical" style={{ width: '100%' }} size={8}>
                {relatedLeads.map((lead, index) => (
                  <div
                    onClick={() => handleRelatedLeadClick(lead)}
                    index={lead.id}
                    className={styles.relatedLeadItem}
                  >
                    <LeadOptionCard key={lead.id} lead={lead} />
                  </div>
                ))}
              </Space>
            </div>
          </Collapse.Panel>
        </Collapse>
        <Button
          icon={<EditOutlined />}
          variant={'text'}
          color={'geekblue'}
          onClick={onUseDifferentContact}
          style={{ padding: 0, height: 'auto', fontSize: 12 }}
        >
          <F
            id="pages.lead.use_different_contact"
            defaultMessage="Use different email/phone"
          />
        </Button>
      </InfoCard>
    )
  );
}
